import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "simple-modal-wrapper"
}
const _hoisted_2 = { class: "simple-modal" }
const _hoisted_3 = { class: "simple-modal__content" }
const _hoisted_4 = { class: "simple-modal__heading" }
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = {
  key: 0,
  class: "form__error pre-wrap"
}
const _hoisted_7 = { class: "flex flex--wrap flex--gap-large flex--align-center" }
const _hoisted_8 = {
  class: "button button--fill button--small",
  type: "submit"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "button button--small",
      type: "button",
      onClick: _cache[0] || (_cache[0] = $event => ($setup.show_form = !$setup.show_form))
    }, _toDisplayString($props.formTitle), 1 /* TEXT */),
    ($setup.show_form === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "simple-modal__close",
              "aria-label": "Close modal",
              onClick: $setup.closeForm
            }),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h2", _hoisted_4, _toDisplayString($props.formTitle), 1 /* TEXT */),
              _createElementVNode("form", {
                onSubmit: _withModifiers($setup.locationNameForm, ["prevent"])
              }, [
                _createVNode($setup["InputComponent"], {
                  value: $setup.localised_form_fields.title,
                  type: "text",
                  "input-id": "title",
                  name: "title",
                  label: "Location name",
                  "group-class": "form__set--fixed-wide",
                  required: true,
                  errors: $setup.localised_form_errors.title || null,
                  "onUpdate:value": _cache[1] || (_cache[1] = new_value => $setup.localised_form_fields.title = new_value)
                }, null, 8 /* PROPS */, ["value", "errors"]),
                ($setup.project_location_form_errors)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($setup.project_location_form_errors), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", _hoisted_8, _toDisplayString($props.formTitle), 1 /* TEXT */),
                  _createElementVNode("button", {
                    class: "a a--no-underline a--small",
                    type: "button",
                    onClick: $setup.closeForm
                  }, " Cancel ")
                ])
              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}